import classNames from 'classnames';
import { Body, BodyProps } from '@components/text';
import './Callout.scss';

export interface CalloutProps extends Omit<BodyProps, 'variant' | 'weight' | 'color' | 'size'> {
  /** Content inside the callout */
  children: React.ReactNode;
  /** Callout size (default: 'large') */
  size?: 'small' | 'medium' | 'large';
  /** Additional className for custom styling */
  className?: string;
}

/**
 * Callout component - displays highlighted text content.
 *
 * @param children - Content to be displayed inside the callout
 * @param size - Size of the callout. Default is 'large'
 * @param className - Additional className for custom styling
 * @param rest - Other body element props
 */
export const Callout: React.FC<CalloutProps> = ({
  children,
  size = 'large',
  className,
  ...rest
}) => (
  <Body
    variant="body-02"
    weight="bold"
    size={size}
    className={classNames('vds-metadata-callout', className)}
    {...rest}>
    {children}
  </Body>
);
